/**
 * Resolvers for scale drop handlers.
 * For Media Devoted | Created By Ciro Autiero
 */

import { getDefaultTldValue } from '@/features/smswiser-campaigns/utils/tldDefaults';
import type { Gateway, LeadsList, ShortLinkTld } from '@/hooks';

export function resolveLeadsListId(
  leadsListName: string | string[] | null | undefined,
  leadsLists: LeadsList[],
): number | null {
  const name = leadsListName == null ? '' : Array.isArray(leadsListName) ? leadsListName[0] ?? '' : String(leadsListName).trim();
  if (!name) return null;
  const found = leadsLists.find((l) => l.name.trim().toLowerCase() === name.toLowerCase());
  return found?.id ?? null;
}

export function resolveRouteId(
  gatewayValue: string | null | undefined,
  routes: Gateway[],
): number | null {
  const raw = (gatewayValue ?? '').trim();
  if (raw) {
    const byName = routes.find((r) => r.name.trim().toLowerCase() === raw.toLowerCase());
    if (byName) return byName.id;
    const parsed = parseInt(raw, 10);
    if (Number.isFinite(parsed)) {
      const byId = routes.find((r) => r.id === parsed);
      if (byId) return byId.id;
    }
    const byContains = routes.find((r) =>
      r.name.trim().toLowerCase().includes(raw.toLowerCase()) ||
      raw.toLowerCase().includes(r.name.trim().toLowerCase()),
    );
    if (byContains) return byContains.id;
  }
  if (routes.length === 1) return routes[0]!.id;
  return null;
}

export function resolveTldValue(
  shortLinkTld: string | null | undefined,
  tlds: ShortLinkTld[],
): string {
  const val = (shortLinkTld ?? '').trim();
  if (!val) return getDefaultTldValue(tlds);
  const found = tlds.find((t) => t.value === val || t.displayName === val);
  return found?.value ?? val;
}

export function resolveWiserId(
  campaignName: string | null | undefined,
  campaigns: Array<{ id: number; name: string }>,
): number | null {
  const name = (campaignName ?? '').trim().toLowerCase();
  if (!name || campaigns.length === 0) return null;
  const found = campaigns.find((c) => (c.name ?? '').trim().toLowerCase() === name);
  return found?.id ?? null;
}
